export type Language = 'en' | 'es' | 'pt';

const en = {
  'language.switch': 'Switch language',
  'language.english': 'English',
  'language.spanish': 'Spanish',
  'language.portuguese': 'Portuguese',

  'theme.white': 'Light mode',
  'theme.dark': 'Dark mode',
  'theme.switchToWhite': 'Switch to light mode',
  'theme.switchToDark': 'Switch to dark mode',

  'layout.nav.dashboard': 'Dashboard',
  'layout.nav.transactions': 'Transactions',
  'layout.nav.apiKeys': 'API Keys',
  'layout.nav.analytics': 'Analytics',
  'layout.nav.clients': 'Clients',
  'layout.nav.contacts': 'Contacts',
  'layout.nav.getPaid': 'Get Paid',
  'layout.nav.wallet': 'Wallet',
  'layout.nav.invoices': 'Payment Links',
  'layout.nav.createInvoice': 'Create Link',
  'layout.nav.profileOptions': 'Profile & Options',
  'layout.invoicePlatform': 'Link Payment Infrastructure',
  'layout.menu.open': 'Open navigation menu',
  'layout.menu.close': 'Close navigation menu',
  'layout.menu.title': 'Menu',
  'layout.menu.language': 'Language',
  'layout.menu.theme': 'Theme',
  'layout.stellarTestnet': 'Stellar Network',
  'layout.backToSite': 'Back to site',
  'layout.balance': 'Balance',
  'layout.noBalance': 'No balance yet',
  'layout.balanceUnavailable': 'Balance unavailable',
  'layout.profile': 'Profile',
  'layout.disconnect': 'Disconnect',
  'layout.connected': 'Connected',
  'layout.notConnected': 'Not connected',
  'layout.defaultUser': 'Link2Pay User',
  'layout.accountMenu': 'Account menu',
  'rail.fiatOfframp': 'Fiat off-ramp',
  'rail.cryptoLabel': 'Crypto',
  'rail.cryptoDesc': 'Receiver keeps {currency} on-chain',
  'rail.fiatDesc': 'Payer pays {currency}, receiver gets {fiat}',
  'rail.setCountryHint': 'Set your country in your profile to unlock local fiat payouts.',
  'rail.comingSoonTitle': '{rail} payouts are coming soon',
  'rail.comingSoonBody': "We're bringing {rail} ({fiat}) payouts to {country}. Leave your email and we'll tell you the moment it goes live.",
  'rail.notifyPlaceholder': 'you@email.com',
  'rail.notifyButton': 'Notify me',
  'rail.notifySubmitting': 'Joining…',
  'rail.notifySuccess': "You're on the list — we'll be in touch.",
  'rail.notifyError': "Couldn't join the waitlist. Please try again.",
  'rail.useCryptoInstead': 'Meanwhile, you can get paid in crypto today.',
  'rail.mainnetOnlyTitle': 'Fiat payouts live on the main app',
  'rail.mainnetOnlyBody': "This test environment runs on the Stellar testnet, where {rail} can't settle real {fiat}. Use the production app for fiat payouts.",
  'rail.mainnetOnlyCta': 'Go to link2pay.xyz',
  'layout.connectWalletTitle': 'Authenticate Your Wallet',
  'login.tagline': 'Invoicing on Stellar',
  'login.title': 'Sign in or create account',
  'login.subtitle': 'New users are registered automatically',
  'login.footer': 'Non-custodial · Powered by Stellar',
  'login.sameMethodHint': 'Use the same method you signed up with.',
  'login.trustNonCustodial': 'Non-custodial',
  'login.trustFast': 'Settles in ~5s',
  'login.trustFees': 'Near-zero fees',
  'layout.connectWalletDescription':
    'Connect your Freighter wallet to access your dashboard, generate payment links, and manage settlements on Stellar.',

  'profile.linkedAccounts': 'Linked Accounts',
  'profile.linkedAccountsDesc': 'Connect social accounts to sign in with any of them.',
  'profile.linked': 'Linked',
  'profile.notLinked': 'Not linked',
  'profile.link': 'Link',
  'profile.linkConflict': 'This account is already linked to another user. Sign in with that account first.',

  'marketing.nav.home': 'Home',
  'marketing.nav.features': 'Features',
  'marketing.nav.sdk': 'SDK',
  'marketing.nav.pricing': 'Pricing',
  'marketing.nav.about': 'About',
  'marketing.connectWallet': 'Connect Wallet',
  'marketing.connecting': 'Connecting...',
  'marketing.disconnect': 'Disconnect',
  'marketing.dashboard': 'Dashboard',
  'marketing.openApp': 'Open app',
  'marketing.footerDescription':
    'The bridge between crypto and your bank account. Your customer pays global, you receive local. On the Stellar network.',
  'marketing.availableWorldwide': 'Available globally on the Stellar network',
  'marketing.product': 'Product',
  'marketing.company': 'Company',
  'marketing.network': 'Network',
  'marketing.builtOnStellar': 'Built on Stellar',
  'marketing.exploreTransactions': 'Explore transactions',
  'marketing.terms': 'Terms',
  'marketing.privacy': 'Privacy',
  'marketing.madeWith': 'Made with',
  'marketing.forFreelancers': 'for builders worldwide',
  'marketing.forLatam': 'for Latin America',
  'marketing.rightsReserved': '© 2026 Link2Pay · All rights reserved.',
  'marketing.stellarTestnet': 'Link2Pay on Stellar',

  'wallet.disconnect': 'Disconnect',
  'wallet.connecting': 'Connecting...',
  'wallet.connectFreighter': 'Connect Freighter Wallet',
  'wallet.connectWallet': 'Connect Wallet',
  'wallet.detected': 'Detected',
  'wallet.tapToConnect': 'Tap to connect',
  'wallet.install': 'Install',
  'wallet.selectWallet': 'Select a wallet to pay',
  'wallet.connectToPay': 'Connect to pay',
  'wallet.payingFrom': 'Paying from',
  'wallet.loading': 'Loading wallets…',
  'wallet.connectError': 'Connection cancelled or failed.',
  'wallet.addressError': 'Could not get the wallet address.',
  'wallet.showMore': 'Show more',

  'payment.loadingInvoice': 'Loading payment link...',
  'payment.invoiceNotFound': 'Payment link not found',
  'payment.invoicePayment': 'Payment Link Checkout',
  'payment.from': 'From',
  'payment.to': 'To',
  'payment.freelancer': 'Merchant',
  'payment.subtotal': 'Subtotal',
  'payment.tax': 'Tax ({rate}%)',
  'payment.totalDue': 'Total Due',
  'payment.connectWalletPrompt': 'Connect your wallet to pay this link',
  'payment.payingFrom': 'Paying from:',
  'payment.payAmount': 'Pay {amount}',
  'payment.enterAmount': 'Enter amount',
  'payment.enterAmountPrompt': 'Enter an amount to continue',
  'payment.openAmountTitle': 'Open amount',
  'payment.openAmountSubtitle': 'Enter the amount you want to pay below.',
  'payment.approveTransaction': "You'll be asked to approve the transaction in your wallet",
  'payment.buildingTransaction': 'Building transaction...',
  'payment.pleaseApprove': 'Please approve in your wallet',
  'payment.confirmingNetwork': 'Confirming on Stellar network...',
  'payment.usuallyTakes': 'This usually takes 3-5 seconds',
  'payment.refreshStatus': 'Refresh status',
  'payment.paymentSuccessful': 'Payment Successful',
  'payment.amountSent': '{amount} has been sent',
  'payment.viewExplorer': 'View on Stellar Explorer ->',
  'payment.paymentFailed': 'Payment Failed',
  'payment.tryAgain': 'Try Again',
  'payment.invoiceExpiredTitle': 'This link has expired',
  'payment.invoiceExpiredBody': 'This payment link is no longer valid. Please ask the sender for a new one.',
  'payment.invoiceCancelledTitle': 'This link was cancelled',
  'payment.invoiceCancelledBody': 'This payment link has been cancelled by the sender.',
  'payment.poweredBy': 'Powered by Link2Pay | Payments on the Stellar Network',
  'payment.txSubmissionFailed': 'Transaction submission failed',
  'payment.paymentFailedDefault': 'Payment failed',
  'payment.simulatedSettlement': 'Simulated Bre-B settlement (demo)',
  'payment.usdEquivalent': '≈ ${amount} USD',
  'payment.requiresTestnet': 'This payment requires Stellar Testnet',
  'payment.requiresMainnet': 'This payment requires Stellar Mainnet',
  'payment.networkMismatchTitle': 'Network Mismatch — Payment Blocked',
  'payment.networkMismatchDesc': 'Your Freighter wallet is on {current}, but this invoice requires {required}.',
  'payment.switchInstructions': 'How to switch Freighter to {network}:',
  'payment.switchStep1': 'Click the Freighter extension in your browser',
  'payment.switchStep2': 'Click the Settings icon (gear) in the top right',
  'payment.switchStep3': 'Find the "Network" section',
  'payment.switchStep4': 'Select {network}',
  'payment.switchStep5': 'This page will detect the change automatically',
  'payment.showInstructions': 'Show instructions',
  'payment.disconnectReconnect': 'Disconnect and reconnect on correct network',
  'payment.desktopConnectRequired': 'Desktop payments require Freighter connected in-browser. Connect your wallet and try again.',
  'payment.sep7NoHandlerDesktop': 'No wallet handler found for this payment link. Connect Freighter in-browser or use a mobile wallet app that supports SEP-7.',
  'payment.sep7NoHandlerMobile': 'No compatible Stellar wallet app was detected. Install a wallet with SEP-7 support and try again.',
  'payment.testnetPayment': 'Testnet payment',
  'payment.mainnetPayment': 'Mainnet payment',
  'payment.paymentBlocked': 'Payment blocked · Wrong network',
  'payment.doc.invoice': 'Invoice',
  'payment.doc.billTo': 'Bill To',
  'payment.doc.issueDate': 'Issue Date',
  'payment.doc.dueDate': 'Due Date',
  'payment.doc.currency': 'Currency',
  'payment.doc.description': 'Description',
  'payment.doc.qty': 'Qty',
  'payment.doc.hrs': 'Hrs',
  'payment.doc.unit': 'Unit',
  'payment.doc.ratePerHr': 'Rate/hr',
  'payment.doc.amount': 'Amount',
  'payment.doc.notes': 'Notes',
  'payment.doc.taxId': 'Tax ID',
  'payment.doc.taxLabel': 'Tax',
  'payment.offramp.title': 'Fiat off-ramp · Bre-B (COP)',
  'payment.offramp.youPay': 'You pay',
  'payment.offramp.receiverGets': 'Receiver gets',
  'payment.offramp.toLlave': 'To Bre-B llave',
  'payment.offramp.belowMinimum': 'Below the Bre-B payout minimum ({min} COP) — this invoice cannot settle in pesos.',
  'payment.offramp.oracleEstimate': 'Live oracle estimate: ≈ ${amount} COP (Reflector — not the firm quote)',
  'payment.offramp.amountToPay': 'Amount to pay ({currency})',
  'payment.offramp.preparing': 'Preparing…',
  'payment.offramp.continue': 'Continue',
  'payment.offramp.amountHelp': 'You choose the amount; the receiver gets the equivalent in COP via Bre-B.',
  'payment.offramp.receiverPreparing': 'The receiver is still setting up this payout with the anchor.',
  'payment.offramp.checkBack': 'Check back shortly — this page updates automatically.',
  'payment.offramp.connectToPay': 'Connect a Stellar wallet to pay USDC to the anchor.',
  'payment.offramp.payingFrom': 'Paying from',
  'payment.offramp.payWith': 'Pay with',
  'payment.offramp.direct': '(direct)',
  'payment.offramp.pathPreview': 'You send {preview}; anchor receives exactly {amount}.',
  'payment.offramp.payWithAsset': 'Pay with {asset} to anchor',
  'payment.offramp.payToAnchor': 'Pay {amount} to anchor',
  'payment.offramp.anchorHold': 'Your wallet pays the anchor directly with the exact memo. Link2Pay never holds your funds.',
  'payment.offramp.signingPayment': 'Building and signing your USDC payment…',
  'payment.offramp.settlingCop': 'USDC received — anchor is settling COP to the Bre-B llave…',
  'payment.offramp.pageAutoUpdates': 'This page updates automatically.',
  'payment.offramp.settledTitle': 'Settled to fiat',
  'payment.offramp.settledBody': '≈ ${amount} COP delivered to {alias}',
  'payment.offramp.settledBodyNoAmount': 'COP delivered to the Bre-B llave',
  'payment.offramp.theBreBLlave': 'the Bre-B llave',
  'payment.offramp.viewOnchainPayment': 'View on-chain USDC payment',
  'payment.offramp.viewOnchainReceipt': 'View on-chain receipt',
  'payment.offramp.offrampFailed': 'The off-ramp could not be completed.',
  'payment.offramp.anchorError': 'The anchor reported an error completing the payout.',
  'payment.offramp.enterPositiveAmount': 'Enter an amount greater than 0.',
  'payment.offramp.couldNotSetAmount': 'Could not set the amount.',
  'payment.offramp.txSubmissionFailed': 'Transaction submission failed.',
  'payment.offramp.noSwapRoute': 'No swap route for {source} right now — pay {target} directly instead.',
  'payment.offramp.paymentFailed': 'Payment failed.',

  'invoiceStatus.draft': 'Draft',
  'invoiceStatus.pending': 'Pending',
  'invoiceStatus.awaitingAnchor': 'Awaiting Anchor',
  'invoiceStatus.awaitingPayment': 'Awaiting Payment',
  'invoiceStatus.processing': 'Processing',
  'invoiceStatus.paid': 'Paid',
  'invoiceStatus.settling': 'Settling',
  'invoiceStatus.settledFiat': 'Settled (Fiat)',
  'invoiceStatus.anchorError': 'Anchor Error',
  'invoiceStatus.needsKyc': 'KYC Required',
  'invoiceStatus.failed': 'Failed',
  'invoiceStatus.expired': 'Expired',
  'invoiceStatus.cancelled': 'Cancelled',
} as const;

type TranslationKey = keyof typeof en;

const es: Record<TranslationKey, string> = {
  'language.switch': 'Cambiar idioma',
  'language.english': 'Inglés',
  'language.spanish': 'Español',
  'language.portuguese': 'Portugués',

  'theme.white': 'Modo claro',
  'theme.dark': 'Modo oscuro',
  'theme.switchToWhite': 'Cambiar a modo claro',
  'theme.switchToDark': 'Cambiar a modo oscuro',

  'layout.nav.dashboard': 'Panel',
  'layout.nav.transactions': 'Transacciones',
  'layout.nav.apiKeys': 'API Keys',
  'layout.nav.analytics': 'Analítica',
  'layout.nav.clients': 'Clientes',
  'layout.nav.contacts': 'Contactos',
  'layout.nav.getPaid': 'Cobrar',
  'layout.nav.wallet': 'Wallet',
  'layout.nav.invoices': 'Links de pago',
  'layout.nav.createInvoice': 'Crear link',
  'layout.nav.profileOptions': 'Perfil y opciones',
  'layout.invoicePlatform': 'Infraestructura de links de pago',
  'layout.menu.open': 'Abrir menú de navegación',
  'layout.menu.close': 'Cerrar menú de navegación',
  'layout.menu.title': 'Menú',
  'layout.menu.language': 'Idioma',
  'layout.menu.theme': 'Tema',
  'layout.stellarTestnet': 'Red Stellar',
  'layout.backToSite': 'Volver al sitio',
  'layout.balance': 'Saldo',
  'layout.noBalance': 'Sin saldo todavía',
  'layout.balanceUnavailable': 'Saldo no disponible',
  'layout.profile': 'Perfil',
  'layout.disconnect': 'Desconectar',
  'layout.connected': 'Conectado',
  'layout.notConnected': 'No conectado',
  'layout.defaultUser': 'Usuario Link2Pay',
  'layout.accountMenu': 'Menú de cuenta',
  'rail.fiatOfframp': 'Retiro a fiat',
  'rail.cryptoLabel': 'Cripto',
  'rail.cryptoDesc': 'El receptor conserva {currency} on-chain',
  'rail.fiatDesc': 'El pagador paga {currency}, el receptor recibe {fiat}',
  'rail.setCountryHint': 'Configura tu país en tu perfil para habilitar pagos locales en fiat.',
  'rail.comingSoonTitle': 'Los pagos con {rail} llegarán pronto',
  'rail.comingSoonBody': 'Estamos habilitando pagos con {rail} ({fiat}) en {country}. Deja tu correo y te avisamos apenas esté disponible.',
  'rail.notifyPlaceholder': 'tu@correo.com',
  'rail.notifyButton': 'Avísame',
  'rail.notifySubmitting': 'Enviando…',
  'rail.notifySuccess': 'Estás en la lista — te contactaremos.',
  'rail.notifyError': 'No se pudo unir a la lista. Intenta de nuevo.',
  'rail.useCryptoInstead': 'Mientras tanto, puedes cobrar en cripto hoy mismo.',
  'rail.mainnetOnlyTitle': 'Los cobros en fiat viven en la app principal',
  'rail.mainnetOnlyBody': 'Este entorno de prueba corre sobre la testnet de Stellar, donde {rail} no puede liquidar {fiat} reales. Usa la app de producción para cobros en fiat.',
  'rail.mainnetOnlyCta': 'Ir a link2pay.xyz',
  'layout.connectWalletTitle': 'Autentifica tu wallet',
  'login.tagline': 'Facturación en Stellar',
  'login.title': 'Inicia sesión o crea tu cuenta',
  'login.subtitle': 'Los nuevos usuarios se registran automáticamente',
  'login.footer': 'No custodial · Impulsado por Stellar',
  'login.sameMethodHint': 'Usa el mismo método con el que te registraste.',
  'login.trustNonCustodial': 'No custodial',
  'login.trustFast': 'Liquida en ~5s',
  'login.trustFees': 'Comisiones casi nulas',
  'layout.connectWalletDescription':
    'Conecta tu wallet Freighter para acceder al panel, generar links de pago y gestionar liquidaciones en Stellar.',

  'profile.linkedAccounts': 'Cuentas vinculadas',
  'profile.linkedAccountsDesc': 'Conecta cuentas sociales para iniciar sesión con cualquiera de ellas.',
  'profile.linked': 'Vinculada',
  'profile.notLinked': 'No vinculada',
  'profile.link': 'Vincular',
  'profile.linkConflict': 'Esta cuenta ya está vinculada a otro usuario. Inicia sesión con esa cuenta primero.',

  'marketing.nav.home': 'Inicio',
  'marketing.nav.features': 'Funciones',
  'marketing.nav.sdk': 'SDK',
  'marketing.nav.pricing': 'Precios',
  'marketing.nav.about': 'Nosotros',
  'marketing.connectWallet': 'Conectar wallet',
  'marketing.connecting': 'Conectando...',
  'marketing.disconnect': 'Desconectar',
  'marketing.dashboard': 'Panel',
  'marketing.openApp': 'Abrir la app',
  'marketing.footerDescription':
    'El puente entre crypto y tu cuenta bancaria. Tu cliente paga global, vos recibís local. Sobre la red Stellar.',
  'marketing.availableWorldwide': 'Disponible globalmente en la red Stellar',
  'marketing.product': 'Producto',
  'marketing.company': 'Empresa',
  'marketing.network': 'Red',
  'marketing.builtOnStellar': 'Construido sobre Stellar',
  'marketing.exploreTransactions': 'Explorá transacciones',
  'marketing.terms': 'Términos',
  'marketing.privacy': 'Privacidad',
  'marketing.madeWith': 'Hecho con',
  'marketing.forFreelancers': 'para builders en todo el mundo',
  'marketing.forLatam': 'para LatAm',
  'marketing.rightsReserved': '© 2026 Link2Pay · Todos los derechos reservados.',
  'marketing.stellarTestnet': 'Link2Pay en Stellar',

  'wallet.disconnect': 'Desconectar',
  'wallet.connecting': 'Conectando...',
  'wallet.connectFreighter': 'Conectar wallet Freighter',
  'wallet.connectWallet': 'Conectar wallet',
  'wallet.detected': 'Detectada',
  'wallet.tapToConnect': 'Toca para conectar',
  'wallet.install': 'Instalar',
  'wallet.selectWallet': 'Elige una wallet para pagar',
  'wallet.connectToPay': 'Conecta para pagar',
  'wallet.payingFrom': 'Pagando desde',
  'wallet.loading': 'Cargando wallets…',
  'wallet.connectError': 'Conexión cancelada o fallida.',
  'wallet.addressError': 'No se pudo obtener la dirección de la wallet.',
  'wallet.showMore': 'Ver más',

  'payment.loadingInvoice': 'Cargando link de pago...',
  'payment.invoiceNotFound': 'Link de pago no encontrado',
  'payment.invoicePayment': 'Checkout de link de pago',
  'payment.from': 'De',
  'payment.to': 'Para',
  'payment.freelancer': 'Comercio',
  'payment.subtotal': 'Subtotal',
  'payment.tax': 'Impuesto ({rate}%)',
  'payment.totalDue': 'Total pendiente',
  'payment.connectWalletPrompt': 'Conecta tu wallet para pagar este link',
  'payment.payingFrom': 'Pagando desde:',
  'payment.payAmount': 'Pagar {amount}',
  'payment.enterAmount': 'Ingresa el monto',
  'payment.enterAmountPrompt': 'Ingresa un monto para continuar',
  'payment.openAmountTitle': 'Monto abierto',
  'payment.openAmountSubtitle': 'Ingresa abajo el monto que deseas pagar.',
  'payment.approveTransaction': 'Debes aprobar la transacción en tu wallet',
  'payment.buildingTransaction': 'Construyendo transacción...',
  'payment.pleaseApprove': 'Por favor aprueba en tu wallet',
  'payment.confirmingNetwork': 'Confirmando en la red Stellar...',
  'payment.usuallyTakes': 'Esto suele tardar de 3 a 5 segundos',
  'payment.refreshStatus': 'Actualizar estado',
  'payment.paymentSuccessful': 'Pago exitoso',
  'payment.amountSent': 'Se envió {amount}',
  'payment.viewExplorer': 'Ver en Stellar Explorer ->',
  'payment.paymentFailed': 'Pago fallido',
  'payment.tryAgain': 'Intentar de nuevo',
  'payment.invoiceExpiredTitle': 'Este link ha expirado',
  'payment.invoiceExpiredBody': 'Este link de pago ya no es válido. Pídele uno nuevo a quien te lo envió.',
  'payment.invoiceCancelledTitle': 'Este link fue cancelado',
  'payment.invoiceCancelledBody': 'Quien te envió este link de pago lo ha cancelado.',
  'payment.poweredBy': 'Impulsado por Link2Pay | Pagos en la red Stellar',
  'payment.txSubmissionFailed': 'Falló el envío de la transacción',
  'payment.paymentFailedDefault': 'El pago falló',
  'payment.simulatedSettlement': 'Liquidación Bre-B simulada (demo)',
  'payment.usdEquivalent': '≈ ${amount} USD',
  'payment.requiresTestnet': 'Este pago requiere Stellar Testnet',
  'payment.requiresMainnet': 'Este pago requiere Stellar Mainnet',
  'payment.networkMismatchTitle': 'Red incompatible — Pago bloqueado',
  'payment.networkMismatchDesc': 'Tu wallet Freighter está en {current}, pero esta factura requiere {required}.',
  'payment.switchInstructions': 'Cómo cambiar Freighter a {network}:',
  'payment.switchStep1': 'Haz clic en la extensión Freighter en tu navegador',
  'payment.switchStep2': 'Haz clic en el ícono de Configuración (engranaje) arriba a la derecha',
  'payment.switchStep3': 'Busca la sección "Network"',
  'payment.switchStep4': 'Selecciona {network}',
  'payment.switchStep5': 'Esta página detectará el cambio automáticamente',
  'payment.showInstructions': 'Mostrar instrucciones',
  'payment.disconnectReconnect': 'Desconectar y reconectar en la red correcta',
  'payment.desktopConnectRequired': 'En desktop, el pago requiere Freighter conectado en el navegador. Conecta la wallet e intenta de nuevo.',
  'payment.sep7NoHandlerDesktop': 'No se encontro un manejador de wallet para este link. Conecta Freighter en el navegador o usa una app movil compatible con SEP-7.',
  'payment.sep7NoHandlerMobile': 'No se detecto una app de wallet Stellar compatible. Instala una wallet con soporte SEP-7 e intenta de nuevo.',
  'payment.testnetPayment': 'Pago en testnet',
  'payment.mainnetPayment': 'Pago en mainnet',
  'payment.paymentBlocked': 'Pago bloqueado · Red incorrecta',
  'payment.doc.invoice': 'Factura',
  'payment.doc.billTo': 'Facturar a',
  'payment.doc.issueDate': 'Fecha de emisión',
  'payment.doc.dueDate': 'Fecha de vencimiento',
  'payment.doc.currency': 'Moneda',
  'payment.doc.description': 'Descripción',
  'payment.doc.qty': 'Cant.',
  'payment.doc.hrs': 'Hrs',
  'payment.doc.unit': 'Unidad',
  'payment.doc.ratePerHr': 'Tarifa/hr',
  'payment.doc.amount': 'Monto',
  'payment.doc.notes': 'Notas',
  'payment.doc.taxId': 'ID fiscal',
  'payment.doc.taxLabel': 'Impuesto',
  'payment.offramp.title': 'Off-ramp a fiat · Bre-B (COP)',
  'payment.offramp.youPay': 'Vos pagás',
  'payment.offramp.receiverGets': 'El receptor recibe',
  'payment.offramp.toLlave': 'A la llave Bre-B',
  'payment.offramp.belowMinimum': 'Por debajo del mínimo de pago de Bre-B ({min} COP) — esta factura no puede liquidarse en pesos.',
  'payment.offramp.oracleEstimate': 'Estimación en vivo del oráculo: ≈ ${amount} COP (Reflector — no es la cotización firme)',
  'payment.offramp.amountToPay': 'Monto a pagar ({currency})',
  'payment.offramp.preparing': 'Preparando…',
  'payment.offramp.continue': 'Continuar',
  'payment.offramp.amountHelp': 'Vos elegís el monto; el receptor recibe el equivalente en COP vía Bre-B.',
  'payment.offramp.receiverPreparing': 'El receptor todavía está configurando este pago con el anchor.',
  'payment.offramp.checkBack': 'Volvé en un momento — esta página se actualiza sola.',
  'payment.offramp.connectToPay': 'Conectá una wallet Stellar para pagar USDC al anchor.',
  'payment.offramp.payingFrom': 'Pagando desde',
  'payment.offramp.payWith': 'Pagar con',
  'payment.offramp.direct': '(directo)',
  'payment.offramp.pathPreview': 'Vos enviás {preview}; el anchor recibe exactamente {amount}.',
  'payment.offramp.payWithAsset': 'Pagar con {asset} al anchor',
  'payment.offramp.payToAnchor': 'Pagar {amount} al anchor',
  'payment.offramp.anchorHold': 'Tu wallet le paga al anchor directamente con el memo exacto. Link2Pay nunca retiene tus fondos.',
  'payment.offramp.signingPayment': 'Construyendo y firmando tu pago en USDC…',
  'payment.offramp.settlingCop': 'USDC recibido — el anchor está liquidando COP a la llave Bre-B…',
  'payment.offramp.pageAutoUpdates': 'Esta página se actualiza automáticamente.',
  'payment.offramp.settledTitle': 'Liquidado a fiat',
  'payment.offramp.settledBody': '≈ ${amount} COP entregados a {alias}',
  'payment.offramp.settledBodyNoAmount': 'COP entregados a la llave Bre-B',
  'payment.offramp.theBreBLlave': 'la llave Bre-B',
  'payment.offramp.viewOnchainPayment': 'Ver pago USDC on-chain',
  'payment.offramp.viewOnchainReceipt': 'Ver recibo on-chain',
  'payment.offramp.offrampFailed': 'No se pudo completar el off-ramp.',
  'payment.offramp.anchorError': 'El anchor reportó un error al completar el pago.',
  'payment.offramp.enterPositiveAmount': 'Ingresá un monto mayor a 0.',
  'payment.offramp.couldNotSetAmount': 'No se pudo establecer el monto.',
  'payment.offramp.txSubmissionFailed': 'Falló el envío de la transacción.',
  'payment.offramp.noSwapRoute': 'No hay ruta de intercambio para {source} ahora — pagá {target} directamente.',
  'payment.offramp.paymentFailed': 'El pago falló.',

  'invoiceStatus.draft': 'Borrador',
  'invoiceStatus.pending': 'Pendiente',
  'invoiceStatus.awaitingAnchor': 'Esperando Anchor',
  'invoiceStatus.awaitingPayment': 'Esperando Pago',
  'invoiceStatus.processing': 'Procesando',
  'invoiceStatus.paid': 'Pagado',
  'invoiceStatus.settling': 'Liquidando',
  'invoiceStatus.settledFiat': 'Liquidado (Fiat)',
  'invoiceStatus.anchorError': 'Error del Anchor',
  'invoiceStatus.needsKyc': 'KYC Requerido',
  'invoiceStatus.failed': 'Fallido',
  'invoiceStatus.expired': 'Expirado',
  'invoiceStatus.cancelled': 'Cancelado',
};

const pt: Record<TranslationKey, string> = {
  'language.switch': 'Mudar idioma',
  'language.english': 'Inglês',
  'language.spanish': 'Espanhol',
  'language.portuguese': 'Português',

  'theme.white': 'Modo claro',
  'theme.dark': 'Modo escuro',
  'theme.switchToWhite': 'Mudar para modo claro',
  'theme.switchToDark': 'Mudar para modo escuro',

  'layout.nav.dashboard': 'Painel',
  'layout.nav.transactions': 'Transações',
  'layout.nav.apiKeys': 'API Keys',
  'layout.nav.analytics': 'Analítica',
  'layout.nav.clients': 'Clientes',
  'layout.nav.contacts': 'Contatos',
  'layout.nav.getPaid': 'Receber',
  'layout.nav.wallet': 'Wallet',
  'layout.nav.invoices': 'Links de pagamento',
  'layout.nav.createInvoice': 'Criar link',
  'layout.nav.profileOptions': 'Perfil e opções',
  'layout.invoicePlatform': 'Infraestrutura de links de pagamento',
  'layout.menu.open': 'Abrir menu de navegação',
  'layout.menu.close': 'Fechar menu de navegação',
  'layout.menu.title': 'Menu',
  'layout.menu.language': 'Idioma',
  'layout.menu.theme': 'Tema',
  'layout.stellarTestnet': 'Rede Stellar',
  'layout.backToSite': 'Voltar ao site',
  'layout.balance': 'Saldo',
  'layout.noBalance': 'Sem saldo ainda',
  'layout.balanceUnavailable': 'Saldo indisponível',
  'layout.profile': 'Perfil',
  'layout.disconnect': 'Desconectar',
  'layout.connected': 'Conectado',
  'layout.notConnected': 'Não conectado',
  'layout.defaultUser': 'Usuário Link2Pay',
  'layout.accountMenu': 'Menu da conta',
  'rail.fiatOfframp': 'Saque para fiat',
  'rail.cryptoLabel': 'Cripto',
  'rail.cryptoDesc': 'O recebedor mantém {currency} on-chain',
  'rail.fiatDesc': 'O pagador paga {currency}, o recebedor recebe {fiat}',
  'rail.setCountryHint': 'Defina seu país no seu perfil para habilitar pagamentos locais em fiat.',
  'rail.comingSoonTitle': 'Pagamentos com {rail} chegam em breve',
  'rail.comingSoonBody': 'Estamos trazendo pagamentos com {rail} ({fiat}) para {country}. Deixe seu email e avisaremos assim que estiver disponível.',
  'rail.notifyPlaceholder': 'voce@email.com',
  'rail.notifyButton': 'Avise-me',
  'rail.notifySubmitting': 'Enviando…',
  'rail.notifySuccess': 'Você está na lista — entraremos em contato.',
  'rail.notifyError': 'Não foi possível entrar na lista. Tente novamente.',
  'rail.useCryptoInstead': 'Enquanto isso, você pode receber em cripto hoje.',
  'rail.mainnetOnlyTitle': 'Os saques em fiat vivem no app principal',
  'rail.mainnetOnlyBody': 'Este ambiente de teste roda na testnet da Stellar, onde {rail} não pode liquidar {fiat} reais. Use o app de produção para saques em fiat.',
  'rail.mainnetOnlyCta': 'Ir para link2pay.xyz',
  'layout.connectWalletTitle': 'Autentique sua wallet',
  'login.tagline': 'Faturamento na Stellar',
  'login.title': 'Entre ou crie sua conta',
  'login.subtitle': 'Novos usuários são registrados automaticamente',
  'login.footer': 'Não custodial · Powered by Stellar',
  'login.sameMethodHint': 'Use o mesmo método com o qual você se cadastrou.',
  'login.trustNonCustodial': 'Não custodial',
  'login.trustFast': 'Liquida em ~5s',
  'login.trustFees': 'Taxas quase nulas',
  'layout.connectWalletDescription':
    'Conecte sua wallet Freighter para acessar o painel, gerar links de pagamento e gerenciar liquidações na Stellar.',

  'profile.linkedAccounts': 'Contas vinculadas',
  'profile.linkedAccountsDesc': 'Conecte contas sociais para entrar com qualquer uma delas.',
  'profile.linked': 'Vinculada',
  'profile.notLinked': 'Não vinculada',
  'profile.link': 'Vincular',
  'profile.linkConflict': 'Esta conta já está vinculada a outro usuário. Entre com essa conta primeiro.',

  'marketing.nav.home': 'Início',
  'marketing.nav.features': 'Recursos',
  'marketing.nav.sdk': 'SDK',
  'marketing.nav.pricing': 'Preços',
  'marketing.nav.about': 'Sobre',
  'marketing.connectWallet': 'Conectar wallet',
  'marketing.connecting': 'Conectando...',
  'marketing.disconnect': 'Desconectar',
  'marketing.dashboard': 'Painel',
  'marketing.openApp': 'Abrir o app',
  'marketing.footerDescription':
    'A ponte entre as cripto e a sua conta bancária. Seu cliente paga global, você recebe local. Na rede Stellar.',
  'marketing.availableWorldwide': 'Disponível globalmente na rede Stellar',
  'marketing.product': 'Produto',
  'marketing.company': 'Empresa',
  'marketing.network': 'Rede',
  'marketing.builtOnStellar': 'Construído sobre Stellar',
  'marketing.exploreTransactions': 'Explore transações',
  'marketing.terms': 'Termos',
  'marketing.privacy': 'Privacidade',
  'marketing.madeWith': 'Feito com',
  'marketing.forFreelancers': 'para builders no mundo todo',
  'marketing.forLatam': 'para a América Latina',
  'marketing.rightsReserved': '© 2026 Link2Pay · Todos os direitos reservados.',
  'marketing.stellarTestnet': 'Link2Pay na Stellar',

  'wallet.disconnect': 'Desconectar',
  'wallet.connecting': 'Conectando...',
  'wallet.connectFreighter': 'Conectar wallet Freighter',
  'wallet.connectWallet': 'Conectar wallet',
  'wallet.detected': 'Detectada',
  'wallet.tapToConnect': 'Toque para conectar',
  'wallet.install': 'Instalar',
  'wallet.selectWallet': 'Escolha uma wallet para pagar',
  'wallet.connectToPay': 'Conecte para pagar',
  'wallet.payingFrom': 'Pagando de',
  'wallet.loading': 'Carregando wallets…',
  'wallet.connectError': 'Conexão cancelada ou falhou.',
  'wallet.addressError': 'Não foi possível obter o endereço da wallet.',
  'wallet.showMore': 'Ver mais',
  'payment.loadingInvoice': 'Carregando link de pagamento...',
  'payment.invoiceNotFound': 'Link de pagamento não encontrado',
  'payment.invoicePayment': 'Checkout de link de pagamento',
  'payment.from': 'De',
  'payment.to': 'Para',
  'payment.freelancer': 'Comerciante',
  'payment.subtotal': 'Subtotal',
  'payment.tax': 'Imposto ({rate}%)',
  'payment.totalDue': 'Total devido',
  'payment.connectWalletPrompt': 'Conecte sua wallet para pagar este link',
  'payment.payingFrom': 'Pagando de:',
  'payment.payAmount': 'Pagar {amount}',
  'payment.enterAmount': 'Insira o valor',
  'payment.enterAmountPrompt': 'Insira um valor para continuar',
  'payment.openAmountTitle': 'Valor aberto',
  'payment.openAmountSubtitle': 'Insira abaixo o valor que deseja pagar.',
  'payment.approveTransaction': 'Você precisará aprovar a transação na sua wallet',
  'payment.buildingTransaction': 'Montando transação...',
  'payment.pleaseApprove': 'Por favor aprove na sua wallet',
  'payment.confirmingNetwork': 'Confirmando na rede Stellar...',
  'payment.usuallyTakes': 'Isso normalmente leva de 3 a 5 segundos',
  'payment.refreshStatus': 'Atualizar status',
  'payment.paymentSuccessful': 'Pagamento concluído',
  'payment.amountSent': '{amount} foi enviado',
  'payment.viewExplorer': 'Ver no Stellar Explorer ->',
  'payment.paymentFailed': 'Falha no pagamento',
  'payment.tryAgain': 'Tentar novamente',
  'payment.invoiceExpiredTitle': 'Este link expirou',
  'payment.invoiceExpiredBody': 'Este link de pagamento não é mais válido. Peça um novo a quem o enviou.',
  'payment.invoiceCancelledTitle': 'Este link foi cancelado',
  'payment.invoiceCancelledBody': 'Quem enviou este link de pagamento o cancelou.',
  'payment.poweredBy': 'Powered by Link2Pay | Pagamentos na rede Stellar',
  'payment.txSubmissionFailed': 'Falha ao enviar a transação',
  'payment.paymentFailedDefault': 'Falha no pagamento',
  'payment.simulatedSettlement': 'Liquidação Bre-B simulada (demo)',
  'payment.usdEquivalent': '≈ ${amount} USD',
  'payment.requiresTestnet': 'Este pagamento requer Stellar Testnet',
  'payment.requiresMainnet': 'Este pagamento requer Stellar Mainnet',
  'payment.networkMismatchTitle': 'Rede incompatível — Pagamento bloqueado',
  'payment.networkMismatchDesc': 'Sua wallet Freighter está na {current}, mas esta fatura requer {required}.',
  'payment.switchInstructions': 'Como mudar o Freighter para {network}:',
  'payment.switchStep1': 'Clique na extensão Freighter no seu navegador',
  'payment.switchStep2': 'Clique no ícone de Configurações (engrenagem) no canto superior direito',
  'payment.switchStep3': 'Encontre a seção "Network"',
  'payment.switchStep4': 'Selecione {network}',
  'payment.switchStep5': 'Esta página detectará a mudança automaticamente',
  'payment.showInstructions': 'Mostrar instruções',
  'payment.disconnectReconnect': 'Desconectar e reconectar na rede correta',
  'payment.desktopConnectRequired': 'No desktop, o pagamento exige Freighter conectado no navegador. Conecte a wallet e tente novamente.',
  'payment.sep7NoHandlerDesktop': 'Nenhum handler de wallet foi encontrado para este link. Conecte o Freighter no navegador ou use uma carteira mobile com suporte a SEP-7.',
  'payment.sep7NoHandlerMobile': 'Nenhum app de carteira Stellar compativel foi detectado. Instale uma carteira com suporte SEP-7 e tente novamente.',
  'payment.testnetPayment': 'Pagamento na testnet',
  'payment.mainnetPayment': 'Pagamento na mainnet',
  'payment.paymentBlocked': 'Pagamento bloqueado · Rede incorreta',
  'payment.doc.invoice': 'Fatura',
  'payment.doc.billTo': 'Cobrar de',
  'payment.doc.issueDate': 'Data de emissão',
  'payment.doc.dueDate': 'Data de vencimento',
  'payment.doc.currency': 'Moeda',
  'payment.doc.description': 'Descrição',
  'payment.doc.qty': 'Qtd.',
  'payment.doc.hrs': 'Hrs',
  'payment.doc.unit': 'Unidade',
  'payment.doc.ratePerHr': 'Taxa/hr',
  'payment.doc.amount': 'Valor',
  'payment.doc.notes': 'Notas',
  'payment.doc.taxId': 'CNPJ/CPF',
  'payment.doc.taxLabel': 'Imposto',
  'payment.offramp.title': 'Off-ramp para fiat · Bre-B (COP)',
  'payment.offramp.youPay': 'Você paga',
  'payment.offramp.receiverGets': 'O recebedor recebe',
  'payment.offramp.toLlave': 'Para a chave Bre-B',
  'payment.offramp.belowMinimum': 'Abaixo do mínimo de pagamento do Bre-B ({min} COP) — esta fatura não pode ser liquidada em pesos.',
  'payment.offramp.oracleEstimate': 'Estimativa ao vivo do oráculo: ≈ ${amount} COP (Reflector — não é a cotação firme)',
  'payment.offramp.amountToPay': 'Valor a pagar ({currency})',
  'payment.offramp.preparing': 'Preparando…',
  'payment.offramp.continue': 'Continuar',
  'payment.offramp.amountHelp': 'Você escolhe o valor; o recebedor recebe o equivalente em COP via Bre-B.',
  'payment.offramp.receiverPreparing': 'O recebedor ainda está configurando este pagamento com o anchor.',
  'payment.offramp.checkBack': 'Volte em instantes — esta página se atualiza sozinha.',
  'payment.offramp.connectToPay': 'Conecte uma carteira Stellar para pagar USDC ao anchor.',
  'payment.offramp.payingFrom': 'Pagando de',
  'payment.offramp.payWith': 'Pagar com',
  'payment.offramp.direct': '(direto)',
  'payment.offramp.pathPreview': 'Você envia {preview}; o anchor recebe exatamente {amount}.',
  'payment.offramp.payWithAsset': 'Pagar com {asset} ao anchor',
  'payment.offramp.payToAnchor': 'Pagar {amount} ao anchor',
  'payment.offramp.anchorHold': 'Sua carteira paga o anchor diretamente com o memo exato. A Link2Pay nunca retém seus fundos.',
  'payment.offramp.signingPayment': 'Construindo e assinando seu pagamento em USDC…',
  'payment.offramp.settlingCop': 'USDC recebido — o anchor está liquidando COP para a chave Bre-B…',
  'payment.offramp.pageAutoUpdates': 'Esta página se atualiza automaticamente.',
  'payment.offramp.settledTitle': 'Liquidado para fiat',
  'payment.offramp.settledBody': '≈ ${amount} COP entregues a {alias}',
  'payment.offramp.settledBodyNoAmount': 'COP entregues à chave Bre-B',
  'payment.offramp.theBreBLlave': 'a chave Bre-B',
  'payment.offramp.viewOnchainPayment': 'Ver pagamento USDC on-chain',
  'payment.offramp.viewOnchainReceipt': 'Ver recibo on-chain',
  'payment.offramp.offrampFailed': 'Não foi possível concluir o off-ramp.',
  'payment.offramp.anchorError': 'O anchor reportou um erro ao concluir o pagamento.',
  'payment.offramp.enterPositiveAmount': 'Insira um valor maior que 0.',
  'payment.offramp.couldNotSetAmount': 'Não foi possível definir o valor.',
  'payment.offramp.txSubmissionFailed': 'Falha ao enviar a transação.',
  'payment.offramp.noSwapRoute': 'Sem rota de troca para {source} agora — pague {target} diretamente.',
  'payment.offramp.paymentFailed': 'O pagamento falhou.',

  'invoiceStatus.draft': 'Rascunho',
  'invoiceStatus.pending': 'Pendente',
  'invoiceStatus.awaitingAnchor': 'Aguardando Anchor',
  'invoiceStatus.awaitingPayment': 'Aguardando Pagamento',
  'invoiceStatus.processing': 'Processando',
  'invoiceStatus.paid': 'Pago',
  'invoiceStatus.settling': 'Liquidando',
  'invoiceStatus.settledFiat': 'Liquidado (Fiat)',
  'invoiceStatus.anchorError': 'Erro do Anchor',
  'invoiceStatus.needsKyc': 'KYC Necessário',
  'invoiceStatus.failed': 'Falhou',
  'invoiceStatus.expired': 'Expirada',
  'invoiceStatus.cancelled': 'Cancelada',
};

export type { TranslationKey };

export const TRANSLATIONS: Record<Language, Record<TranslationKey, string>> = {
  en,
  es,
  pt,
};
